import { getSelectedBoxId } from '../../utils/productLicensing';

const getAuthToken = () => {
  const user = JSON.parse(sessionStorage.getItem('user') || 'null');
  return user && user.signInUserSession && user.signInUserSession.idToken
    ? user.signInUserSession.idToken.jwtToken
    : '';
};

const request = async (path, options = {}) => {
  const response = await fetch(`${process.env.REACT_APP_BASEURL}${path}`, {
    withCredentials: true,
    ...options,
    headers: {
      Authorization: `Bearer ${getAuthToken()}`,
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.message || 'Request failed');
    error.status = response.status;
    error.data = data;
    throw error;
  }
  return data;
};

export const fetchCampaigns = (boxId) => {
  const params = new URLSearchParams();
  if (boxId) params.set('box_id', boxId);
  const query = params.toString();
  return request(`api/v1/campaigns${query ? `?${query}` : ''}`);
};

export const fetchCampaignRules = () => request('api/v1/campaigns/rules');

export const fetchCampaignAnalytics = (boxId, days) => {
  const params = new URLSearchParams();
  if (boxId) params.set('box_id', boxId);
  if (days) params.set('days', String(days));
  const query = params.toString();
  return request(`api/v1/campaigns/analytics${query ? `?${query}` : ''}`);
};

export const fetchCampaignTemplates = (boxId, channel) => {
  const params = new URLSearchParams();
  params.set('box_id', boxId || '');
  params.set('channel', channel || 'sms');
  return request(`api/v1/campaigns/templates?${params.toString()}`);
};

export const previewCampaign = (payload) =>
  request('api/v1/campaigns/preview', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const createCampaign = (payload) =>
  request('api/v1/campaigns', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const sendCampaign = (payload) =>
  createCampaign({ ...(payload || {}), send: true });

export const updateCampaign = (id, payload) =>
  request(`api/v1/campaigns/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });

export const runCampaignAction = (id, action) =>
  request(`api/v1/campaigns/${id}/action`, {
    method: 'POST',
    body: JSON.stringify({ action }),
  });

export const deleteCampaign = (id) =>
  request(`api/v1/campaigns/${id}`, { method: 'DELETE' });

export const fetchCampaignAudit = (id) =>
  request(`api/v1/campaigns/${id}/audit`);

export const selectedCampaignBoxId = () => getSelectedBoxId();



// WEBPACK FOOTER //
// ./src/components/campaigns/api.js